<template>
  <div class="pb-16 md:pb-0">
    <div
      class="px-3 pb-6 md:px-6"
      v-if="strategies_msg != 'Nenhum investimento encontrado'"
    >
      <performance-header
        v-if="Object.keys(strategies).length > 0"
        @listInvestment="listInvestment"
        @chooseItem="chooseItem"
        @activeLogs="selectedComponent = 'LogsTables'"
        :data="strategies"
        :dateLogs="tab"
        :active_days="investment.active_days"
      ></performance-header>
      <div
        is="transition"
        v-on:enter="enter"
        v-on:leave="leave"
        v-bind:css="false"
        appear
        mode="out-in"
      >
        <component
          v-if="Object.keys(investment).length > 0"
          :is="selectedComponent"
          :data="investment"
        />
      </div>
    </div>
    <div
      v-else
      class="my-16 flex justify-center px-10 text-center md:my-20 md:px-0"
    >
      <div style="max-width: 380px">
        <span v-html="$icons.not_investment"></span>
        <h1 class="pt-6 text-3xl font-bold text-gray-300">
          Vamos começar a investir?
        </h1>
        <p class="text-gray-400">
          Não encontramos nenhum investimento na sua conta. Acesse o marketplace
          para adicionar estratégias à sua conta.
        </p>
        <ontick-button
          @click.native="$router.push({ name: 'Marketplace' })"
          class="mt-4 w-full uppercase"
          >Acessar estratégias</ontick-button
        >
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
// import StrategyResume from "../../components/performance/strategy/strategy-resume.component.vue";
// import OrderTables from "../../components/performance/order/table.component";
// import LogsTables from "../../components/performance/logs/table.component";
export default {
  components: {
    PortfolioHeader: () =>
      import("../components/header/portfolio-header.component.vue"),
    StrategyResume,
    OrderTables,
    // LogsTables,
  },

  data() {
    return {
      tab: {
        main: true,
        orders: false,
        logs: false,
        operation: false,
      },
      selectedComponent: "StrategyResume",
      requestDate: {},
    };
  },
  computed: {
    ...mapState({
      strategies: (state) => state.performance.strategies,
      investment: (state) => state.performance.investment,
      selectedAccount: (state) => state.accountTypes.selectedAccount,
      strategies_msg: (state) => state.performance.strategies_msg,
    }),
  },
  async mounted() {
    if (Object.keys(this.selectedAccount).length > 0) {
      await this.fetchAccounts(this.selectedAccount);
    }
  },
  watch: {
    selectedAccount: {
      deep: true,
      handler(value) {
        this.fetchAccounts(value);
        return value;
      },
    },
  },
  methods: {
    ...mapActions({
      fetchAccounts: "performance/fetchAccounts",
      detailsStrategy: "performance/detailsStrategy",
    }),

    enter(el, done) {
      TweenMax.fromTo(
        el,
        0.5,
        {
          autoAlpha: 0,
          scale: 1.5,
        },
        {
          autoAlpha: 1,
          scale: 1,
          transformOrigin: "50% 50%",
          ease: Power4.easeOut,
          onComplete: done,
        }
      );
    },
    leave(el, done) {
      TweenMax.fromTo(
        el,
        0.5,
        {
          autoAlpha: 1,
          scale: 1,
        },
        {
          autoAlpha: 0,
          scale: 0.95,
          ease: Power4.easeOut,
          onComplete: done,
        }
      );
    },

    chooseItem(value) {
      if (value.label == "Resumo")
        return (this.selectedComponent = "StrategyResume");
      if (value.label == "Ordens")
        return (this.selectedComponent = "OrderTables");
      if (value.label == "Logs") return (this.selectedComponent = "LogsTables");
    },

    listInvestment(investment) {
      this.detailsStrategy(investment);
    },
  },
};
</script>

<style lang="scss" scoped>
// @import "./performance.component.scss";
</style>
